import React from 'react';

import { Redirect, Route } from 'react-router-dom';
import { isAdminUser, isLoggedIn, isStaffUser } from '../utils/auth';

// This is used to determine if a user is authenticated and
// if they are allowed to visit the page they navigated to.

// If they are: they proceed to the page
// If not: they are redirected to the login page.

// If they are authenticated but without the required role they will be redirectec to unauthorized page

const PrivateRoute = props => {
  const { component: Component, staffOnly, adminOnly, ...rest } = props;

  if (!isLoggedIn()) {
    return (
      <Route
        {...rest}
        render={props => {
          const fullUrl = props.location.pathname + props.location.search;
          return (
            <Redirect
              to={{
                pathname: '/',
                search: `?returnUrl=${encodeURIComponent(fullUrl)}`,
              }}
            />
          );
        }}
      />
    );
  }

  if (staffOnly && !isStaffUser() && !isAdminUser()) {
    return <Route {...rest} render={() => <Redirect to={{ pathname: '/unauthorized' }} />} />;
  }

  if (adminOnly && !isAdminUser()) {
    return <Route {...rest} render={() => <Redirect to={{ pathname: '/unauthorized' }} />} />;
  }

  return <Route {...rest} render={props => <Component {...props} />} />;
};

export default PrivateRoute;
